import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { driverSelector, updatedriver } from "../../api/driver";

export default function MyUPI() {
  const dispatch = useDispatch();
  const { current_driver, loading } = useSelector(driverSelector); 

  const driver_id_ = localStorage.getItem("Driver"); 
  const [upiid, setUpiid] = useState(current_driver?.upiid || ""); 
  const [isEditing, setIsEditing] = useState(false); 

  useEffect(() => {
    if (!driver_id_) {
      console.warn("No driver ID found in localStorage.");
    }
    
  }, [driver_id_]);

  
  const handleUpiChange = (e) => {
    setUpiid(e.target.value); 
  };


  const handleSave = async () => {
    if (upiid !== current_driver?.upiid) {
      
      if (driver_id_) {
        await dispatch(updatedriver({ upiid }, driver_id_)); 
        setIsEditing(false); 
      } else {
        console.error("Driver ID is missing.");
      }
    }
  };

  if (loading) {
    return <div>Loading...</div>; 
  }

  return (
    <div className="max-w-2xl mx-auto px-4 mt-48">
      <h1 className="text-2xl font-bold mb-6">UPI ID</h1>

      <div className="bg-white shadow-md rounded-lg p-4 mb-6 border">
        <h2 className="text-lg font-semibold mb-2">My UPI ID</h2>
        
        {isEditing ? (
          <div>
            <input
              type="text"
              value={upiid}
              onChange={handleUpiChange}
              className="border p-2 rounded w-full mb-4"
            />
            <button
              onClick={handleSave}
              className="bg-blue-500 text-white px-4 py-2 rounded"
            >
              Save
            </button>
          </div>
        ) : (
          <div>
            <p className="mb-4">{upiid || "No UPI ID set."}</p>
            <button
              onClick={() => setIsEditing(true)}
              className="bg-yellow-500 text-white px-4 py-2 rounded"
            >
              Update UPI ID
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
